import React from 'react'
import { GridColumn as Column, Grid, GridCellProps } from '@progress/kendo-react-grid'
import { TradingAccountPendingOrderDto } from 'api/Clients/Types/TradingAccountPendingOrderDto'
import { Loading } from 'components/Loading'
import { formatLocalDateUTC } from 'utils/date'
import { TableWithExport } from 'utils/table/withExport'

import '../TradingAccount.scss'

interface Props {
  pendingOrders: TradingAccountPendingOrderDto[]
}

const TradingAccountPendingOrders: React.FC<Props> = ({ pendingOrders }) => {
  return (
    <Loading isLoading={!pendingOrders}>
      <TableWithExport data={pendingOrders || []}>
        <Grid data={pendingOrders} resizable>
          <Column field='login' title='Login' className='trading-account-table-columns__content' />
          <Column
            field='orderNumber'
            title='Order Number'
            className='trading-account-table-columns__number'
          />
          <Column
            cell={(gridCellProps: GridCellProps) => (
              <td className='table-columns__date'>
                {formatLocalDateUTC(gridCellProps.dataItem.openTime, true)}
              </td>
            )}
            title='Open time'
          />
          <Column field='type' title='Type' className='trading-account-table-columns__number' />
          <Column
            field='symbol'
            title='Symbol'
            className='trading-account-table-columns__content'
          />
          <Column field='volume' title='Volume' className='trading-account-table-columns__number' />
          <Column field='lots' title='Lots' className='trading-account-table-columns__number' />
          <Column
            field='openPrice'
            title='Open Price'
            className='trading-account-table-columns__number'
          />
          <Column
            field='stopLossPrice'
            title='StopLoss Price'
            className='trading-account-table-columns__number'
          />
          <Column
            field='takeProfitPrice'
            title='TakeProfit Price'
            className='trading-account-table-columns__number'
          />
        </Grid>
      </TableWithExport>
    </Loading>
  )
}

export default TradingAccountPendingOrders
